module.exports = __webpack_public_path__ + "media/images/blank-e6b8b3e23eb17a191b3bc5fe965c6f49.gif";